import * as Cookie from './cookie';

export const FormatearUrl = (nombre) => {
    let res = nombre.trim().toLowerCase()
        .replace(/,/g, '')
        .replace(/\./g, '')
        .replace(/:/g, '-')
        .replace(/ /g, '-')
        .replace(/\)/g, '')
        .replace(/\(/g, '')
        .replace(/´/g, '')
        .replace(/"/g, '')
        .replace(/#/g, '')
        .replace(/&/g, '')
        .replace(/\//g, '')
        .replace(/\\/g, '')
        .replace(/\?/g, '')
        .replace(/!/g, '')
        .replace(/\*/g, '')
        .replace(/\[/g, '')
        .replace(/\]/g, '')
        .replace(/\{/g, '')
        .replace(/\}/g, '')
        .replace(/~/g, '')
        .replace(/'/g, '')
        .replace(/¨/g, '')
        .replace(/`/g, '')
        .replace(/\^/g, '')
        .replace(/_/g, '')
        .replace(/\+/g, '')
        .replace(/“/g,'')
        .replace(/%/g,'')
        .replace(/”/g,'');

    let replacement = [
        'a', 'a', 'a', 'a', 'a', 'a', 'c', 'e', 'e', 'e', 'e', 'i', 'i', 'i', 'i', 'n', 'o',
        'o', 'o', 'o', 'o', 'u', 'u', 'u', 'u', 'y', 'y'
    ];
    let accents =
    [
        'à', 'á', 'â', 'ã', 'ä', 'å', 'ç', 'é', 'è', 'ê', 'ë', 'ì', 'í', 'î', 'ï', 'ñ', 'ò', 'ó',
        'ô', 'ö', 'õ', 'ù', 'ú', 'û', 'ü', 'ý', 'ÿ'
    ];

    for (let i = 0; i < accents.length; i++) {
        res = res.replace(accents[i], replacement[i]);
    }

    return res;
}

export const formatoUrlAcuTag = (descripcion , id) => {

    return `/${FormatearUrl(descripcion)}-t${id}`;
}

export const formatoUrlAcuFotoTag = (descripcion , id) => {

    return `/fotos-de-${FormatearUrl(descripcion)}-f${id}`;
}
export const formatoUrlAcuAutor = (nombre , id) => {

    return `/autor/${FormatearUrl(nombre)}-${id}`;
}



 export const getRandomInteger = (min, max) => {
        let _min = Math.ceil(min);
        let _max = Math.floor(max+1);
        return Math.floor(Math.random() * (_max - _min)) + _min;
 }


export const getRandom = (data , hasta) => {
    {
        let arrayNotasRandom = [];
        let arraycount = data.length;
        let startIndex = 0;
        let endIndex = arraycount - 1;
        let loopTo = hasta;
        let dataRandom = [];

        if (endIndex < loopTo) loopTo = arraycount;

        for (let i = startIndex; i < loopTo; i++) {
            //Obtenego el primer numero random
            let _randomNumIndex = getRandomInteger(0, endIndex);

            //Cargo el numero random en el array
            arrayNotasRandom.push(_randomNumIndex);

            //Si no es el 1er numero y si esta en el array buscar otro numero
            if (arrayNotasRandom.length > 1 && jQuery.inArray(_randomNumIndex, arrayNotasRandom) > -1) {
                let exitwhile = 0;
                _randomNumIndex = getRandomInteger(0, endIndex);
                while (jQuery.inArray(_randomNumIndex, arrayNotasRandom) > -1 && exitwhile < 400) {
                    exitwhile++;
                    _randomNumIndex = getRandomInteger(0, endIndex);
                }
                arrayNotasRandom[i] = _randomNumIndex;
            }
        }

        for (let ir = 0; ir < arrayNotasRandom.length; ir++) {
            dataRandom.push(data[arrayNotasRandom[ir]]);
        }
     
        return dataRandom;
    }
}

export const scrolledIntoView = (elem) => {
    var element = $(elem);

    if (element.length > 0) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        
        var elemTop = element.offset().top;
        var elemBottom = elemTop + element.height();


        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }
    return false;

}

export const metaRefresh = (time , pagina) => {
    let productoPremiumId = Cookie.LeerCookie("ProductoPremiumId");
    if (productoPremiumId !== "") {
        productoPremiumId = productoPremiumId.replace(/ /g,"").split(",");
    }
    var objPlayers = document.getElementsByClassName("jwplayer");
    if (productoPremiumId.indexOf("5") < 0 || pagina === "home") {
        setInterval(function() {
            if (objPlayers.length > 0) {
                let isPlaying = false;
                for (let i = 0; i < objPlayers.length; i++) {
                    if (jwplayer(i).getState() === "playing") {
                        isPlaying = true;
                        break;
                    }
                }
                if (!isPlaying) {
                    localStorage.setItem("CDmetaRefresh",true);
                    window.location.reload();
                }
            } else {
                localStorage.setItem("CDmetaRefresh",true);
                window.location.reload();
            }

        },time);
    }
}

export const getUrlSitios = (sitioId) => {

    switch (sitioId) {
        case 21:
            return "http://www.revistaohlala.com/";
        case 9:
            return "http://www.rollingstone.com.ar/";
        case 32:
            return "http://www.revistasusana.com/";
        default:
            return "https://www.lanacion.com.ar/";
    }
}



    









// WEBPACK FOOTER //
// ./Statics/scripts/common/utilities.js